import { inject, Injectable, signal } from '@angular/core';
import {
  CountryLanguages,
  FlyoutLangSelector,
  RegionList
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { Observable, Subject } from 'rxjs';
import { Device } from '../../../models/device-type/device-type.interface';
import { DeviceTypeService } from '../../../services/device-type/device-type.service';
import { AppConfigService, CookieHelperService } from '../../../services/utils';
import { ApplicationConfig } from '../../../utils/config';
import { CountryLanguageHelper } from '../../../utils/country-language/country-language-helper';
import { CountryLanguageService } from '../../../utils/country-language/country-language.service';
@Injectable({
  providedIn: 'root'
})
export class FlyoutLangSelectorExtendedFacade {
  flyOutLanguageSelectorContent$!: Observable<FlyoutLangSelector>;
  unsubscribe = new Subject<void>();
  countryLanguageList!: CountryLanguages[];
  regionList!: RegionList[];
  searchList$!: Observable<CountryLanguages[]>;
  searchRegionList!: RegionList[];
  listIndex!: number;
  currentCountryCode!: string;
  currentCLSLanguage!: string;
  selectedRegion!: RegionList;
  selectedRegionCountries!: CountryLanguages[];
  displayButtonText!: string;
  title!: string;
  region!: string;
  location!: string;
  searchPlaceholder!: string;
  searchLabel!: string;
  clsLanguageCodeToChange!: string;
  deviceTypes!: Device;
  indexArray!: boolean[];
  showSelectorModal = signal(false);

  appconfig = inject(ApplicationConfig);
  applicationConfig = inject(AppConfigService);
  countryLangSvc = inject(CountryLanguageService);
  countryLanguageHelper = inject(CountryLanguageHelper);
  _deviceTypeHelper = inject(DeviceTypeService);
  cookieHelper = inject(CookieHelperService);

  setSelectedRegion(countryCode: string | null): void {
    const selectedRegion = countryCode
      ? this.countryLanguageHelper.getRegionForCountryCode(countryCode)
      : this.countryLanguageHelper.getRegionForCountryCode('us');
    if (selectedRegion) {
      this.selectedRegion = selectedRegion;
    }
  }

  setSearchLabel(resText: string): void {
    const searchLabel =
      this.countryLanguageHelper.getTranslatedTextForLanguageCode(
        resText,
        'cls-search-label'
      );
    if (searchLabel) this.searchLabel = searchLabel;
  }

  setPlaceHolder(resText: string): void {
    const searchPlaceholder =
      this.countryLanguageHelper.getTranslatedTextForLanguageCode(
        resText,
        'cls-search-placeholder'
      );
    if (searchPlaceholder) this.searchPlaceholder = searchPlaceholder;
  }

  setLocation(resText: string): void {
    const location =
      this.countryLanguageHelper.getTranslatedTextForLanguageCode(
        resText,
        'cls-location'
      );
    if (location) this.location = location;
  }

  setRegion(resText: string): void {
    const region = this.countryLanguageHelper.getTranslatedTextForLanguageCode(
      resText,
      'cls-region'
    );
    if (region) this.region = region;
  }

  setTitle(resText: string): void {
    const title = this.countryLanguageHelper.getTranslatedTextForLanguageCode(
      resText,
      'cls-title'
    );
    if (title) this.title = title;
  }

  setDisplayButtonText(resText: string): void {
    const displayButtonText =
      resText === 'en'
        ? ''
        : this.countryLanguageHelper.getTranslatedTextForLanguageCode(
            'en',
            'cls-display-button'
          );
    if (displayButtonText) {
      this.displayButtonText;
    }
  }

  setSearchList(searchValue: string): CountryLanguages[] {
    const countryLang: CountryLanguages[] = Object.assign(
      [],
      this.countryLanguageList
    );
    return countryLang
      ?.map((item) => {
        const langList = this.setLangList(searchValue, item);
        if (
          item.countryName.toLowerCase().includes(searchValue.toLowerCase())
        ) {
          return item;
        } else if (langList) {
          return langList;
        }
        return null;
      })
      .filter((item): item is CountryLanguages => item !== null);
  }

  setLangList(
    searchValue: string,
    item: CountryLanguages
  ): CountryLanguages | null {
    const langList = item.languageDtls.filter((lang) => {
      return (
        lang.languageName.toLowerCase().includes(searchValue.toLowerCase()) ||
        lang.countryName.toLowerCase().includes(searchValue.toLowerCase())
      );
    });
    if (langList.length > 0) {
      const new_item = Object.assign({}, item);
      new_item.languageDtls = langList;
      return new_item;
    }
    return null;
  }
}
